/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/common/components/UserCard';
import app from 'flarum/forum/app';
import { slug } from '../common';
import UserGamificationInfos from './components/UserGamificationInfos';

export default function () {
	extend(UserCard.prototype, 'infoItems', function (items) {
		if (app.forum.attribute(`${slug}.gamification.enabled`)) {
			items.add('gamification', <UserGamificationInfos user={this.attrs.user} />, -99);
			// -100 is user bio, so we want to be just before that
		}
	});
}
